import { render, staticRenderFns } from "./IconSvgBank.vue?vue&type=template&id=df28e49e&scoped=true&"
import script from "./IconSvgBank.vue?vue&type=script&lang=js&"
export * from "./IconSvgBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df28e49e",
  null
  
)

export default component.exports